module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Enter the old password")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Old Password"
    },
    model: {
      value: (_vm.credentials.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "oldPassword", $$v)
      },
      expression: "credentials.oldPassword"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Enter the password")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "New Password"
    },
    model: {
      value: (_vm.credentials.newPassword1),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "newPassword1", $$v)
      },
      expression: "credentials.newPassword1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "New Password"
    },
    model: {
      value: (_vm.credentials.newPassword2),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "newPassword2", $$v)
      },
      expression: "credentials.newPassword2"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.passwordChange()
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v("Clear")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2684e43a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/auth/ChangePassword.vue
// module id = 670
// module chunks = 2